type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function ArrowLeftCursiveIcon(props: Props) {
  return (
    <svg
      width={props.width ?? 32}
      height={props.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8389 19C13.8389 17.3433 12.4958 16 10.8389 16C12.4956 16 13.8389 14.657 13.8389 13"
        stroke={props.stroke ?? '#494545'}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.839 16H20"
        stroke={props.stroke ?? '#494545'}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
